import { entityStateReducer } from 'app/models/entityStateSync/reducer';
import { tFunctionType } from 'app/services/localization';
import { LWWDocumentManager, IActionHandler } from 'app/services/rtc/sync/documentmanagers/lww';
import { IDocumentManagerFactory } from 'app/services/rtc/sync/DocumentSpec';
import { KeyPathRootState } from 'app/models/entityStateSync/types';
import { IEntityStateAction } from '@engoo/realtime-protocol/entityState';
import { IDocumentManagerState } from 'app/containers/rtc/DocumentProvider/useDocumentManager';
import { Stream } from '@engoo/realtime-protocol/stream';

type EntityStateSyncManager = LWWDocumentManager<KeyPathRootState, IEntityStateAction>;
type EntityStateActionHandler = IActionHandler<KeyPathRootState, IEntityStateAction>;
export type EntitySyncDocumentManagerState = IDocumentManagerState<KeyPathRootState, EntityStateSyncManager>;

const managerType: IDocumentManagerFactory<
  KeyPathRootState,
  IEntityStateAction,
  EntityStateActionHandler,
  EntityStateSyncManager
> = LWWDocumentManager;

const actionHandler: EntityStateActionHandler = {
  apply: entityStateReducer,
};

export const EntitySyncDocumentSpec = {
  managerType,
  actionHandler,
  initialState:  entityStateReducer(),
  name: (t: tFunctionType) => t('rtc.features.lesson-state.name'),
};

export default {
  [Stream.EntityState]: EntitySyncDocumentSpec,
};
